class BlackFridayButtons {
  constructor(container) {
    this.container = container;
    if (!this.container) return;

    this.buttons = this.container.querySelectorAll('.w-blackfriday-buttons__button');
    this.buttonsWrapper = this.container.querySelector('.w-blackfriday-buttons__buttons-wrapper');
    this.scrollbarThumb = this.container.querySelector('.w-blackfriday-buttons__scrollbar-thumb');

    this.bindEvents();
    this.updateScrollIndicator();
  }

  bindEvents() {
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        this.handleButtonClick(e);
      });
    });

    if (this.buttonsWrapper) {
      this.buttonsWrapper.addEventListener('scroll', () => {
        this.updateScrollIndicator();
      });
    }

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.updateScrollIndicator();
      }, 100);
    });
  }

  handleButtonClick(e) {
    const button = e.currentTarget;
    const filter = button.dataset.filter;
    const productId = button.dataset.productId;

    this.buttons.forEach(btn => {
      btn.classList.remove('w-blackfriday-buttons__button--active');
    });
    button.classList.add('w-blackfriday-buttons__button--active');

    const productSections = document.querySelectorAll('.atc-bundle-sor');
    const separators = document.querySelectorAll('.w-blackfriday-separator');

    if (filter === 'all') {
      productSections.forEach(section => {
        const parent = section.closest('.shopify-section');
        if (parent) {
          parent.style.display = 'block';
          parent.style.paddingBottom = '';
        }
      });
      separators.forEach(separator => {
        const parent = separator.closest('.shopify-section');
        if (parent) {
          parent.style.display = 'block';
        }
      });
    } else if (productId) {
      let lastVisibleSection = null;
      productSections.forEach(section => {
        const parent = section.closest('.shopify-section');
        if (parent) {
          if (section.dataset.productId === productId) {
            parent.style.display = 'block';
            parent.style.paddingBottom = '';
            lastVisibleSection = parent;
          } else {
            parent.style.display = 'none';
          }
        }
      });
      separators.forEach(separator => {
        const parent = separator.closest('.shopify-section');
        if (parent) {
          parent.style.display = 'none';
        }
      });
      if (lastVisibleSection) {
        const isMobile = window.innerWidth <= 990;
        lastVisibleSection.style.paddingBottom = isMobile ? '60px' : '120px';
      }
    }
  }

  updateScrollIndicator() {
    if (!this.buttonsWrapper || !this.scrollbarThumb) return;
    if (window.innerWidth > 990) return;

    const scrollPercentage = this.buttonsWrapper.scrollLeft /
      (this.buttonsWrapper.scrollWidth - this.buttonsWrapper.clientWidth);

    const maxTranslate = this.scrollbarThumb.parentElement.clientWidth - this.scrollbarThumb.clientWidth;
    this.scrollbarThumb.style.transform = `translateX(${scrollPercentage * maxTranslate}px)`;
  }
}

function initializeBlackFridayButtons() {
  const sections = document.querySelectorAll('.w-blackfriday-buttons');
  sections.forEach(section => {
    if (!section.blackFridayButtonsInstance) {
      section.blackFridayButtonsInstance = new BlackFridayButtons(section);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeBlackFridayButtons();
});

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.w-blackfriday-buttons')) {
    initializeBlackFridayButtons();
  }
});
